export {}

type WindowDebugInfo = {
  mode: string
  appEnv: string
  apiUrl: string
  authApiUrl: string
  commitShortSha: string
}

declare global{
  interface Window {
    debugInfo: () => WindowDebugInfo
  }
}

window.debugInfo = () => {
  const debugInfo: WindowDebugInfo = {
    mode: import.meta.env.MODE,
    appEnv: import.meta.env.VITE_FINANCE_PORTAL_ENV,
    apiUrl: import.meta.env.VITE_FINANCE_PORTAL_API_BASE_URL,
    authApiUrl: import.meta.env.VITE_AUTH_SERVICE_BASE_URL,
    commitShortSha: import.meta.env.VITE_COMMIT_SHORT_SHA,
  }

  return debugInfo
}